import { render, staticRenderFns } from "./GlobalTopMessage.vue?vue&type=template&id=31296294&scoped=true&"
import script from "./GlobalTopMessage.vue?vue&type=script&lang=js&"
export * from "./GlobalTopMessage.vue?vue&type=script&lang=js&"
import style0 from "./GlobalTopMessage.vue?vue&type=style&index=0&id=31296294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31296294",
  null
  
)

export default component.exports